import React from 'react';
import { useLocation } from 'react-router-dom';

interface Step {
  path: string;
  label: string;
  shortLabel: string;
}

const STEPS: Step[] = [
  { path: '/getting-started', label: 'Sign Up', shortLabel: 'Sign Up' },
  { path: '/verify-email', label: 'Verify Email', shortLabel: 'Verify' },
  { path: '/select-plans', label: 'Choose Plan', shortLabel: 'Plan' },
  { path: '/payment-verification', label: 'Payment', shortLabel: 'Payment' },
  { path: '/create-organization', label: 'Organization', shortLabel: 'Org' },
  { path: '/configure-structure', label: 'Configure', shortLabel: 'Config' },
  { path: '/complete', label: 'Complete', shortLabel: 'Done' },
];

const StepProgressBar: React.FC = () => {
  const location = useLocation();
  const currentIndex = STEPS.findIndex((s) => s.path === location.pathname);
  const currentStep = currentIndex === -1 ? 0 : currentIndex;
  const progressPercent = ((currentStep) / (STEPS.length - 1)) * 100;

  return (
    <div className="onboarding-step-progress">
      {/* Mobile: compact single-line */}
      <div className="d-md-none">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <span className="step-progress-label">
            Step {currentStep + 1} of {STEPS.length}
          </span>
          <span className="step-progress-name">
            {STEPS[currentStep]?.label}
          </span>
        </div>
        <div className="step-progress-track">
          <div
            className="step-progress-fill"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>

      {/* Desktop: full step indicators */}
      <div className="d-none d-md-block">
        <div className="onboarding-steps">
          {STEPS.map((step, index) => {
            let status = 'pending';
            if (index < currentStep) status = 'completed';
            if (index === currentStep) status = 'active';
            if (index === STEPS.length - 1 && index === currentStep) status = 'completed';

            return (
              <div key={step.path} className={`step ${status}`}>
                <div className="step-number">
                  {status === 'completed' ? (
                    <i className="fa-solid fa-check" />
                  ) : (
                    index + 1
                  )}
                </div>
                <div className="step-title">{step.shortLabel}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StepProgressBar;
